import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { EditUserAchievementUserSettingsFulfilledAction } from '../../domains/userAchievementsSettings/editUserAchievementUserSettingsActions.types';
import type {
  UserNetworkQuestionAchievementsLoadFulfilledAction,
  UserNetworkQuestionAchievementsLoadPendingAction,
  UserNetworkQuestionAchievementsLoadRejectedAction,
} from '../../domains/userNetworkQuestionAchievements/actions.types';

import type { UsersNetworkQuestionAchievements } from './types';
export type UserNetworkQuestionAchievementsAction =
  | EditUserAchievementUserSettingsFulfilledAction
  | UserNetworkQuestionAchievementsLoadFulfilledAction
  | UserNetworkQuestionAchievementsLoadPendingAction
  | UserNetworkQuestionAchievementsLoadRejectedAction;
const initialState: UsersNetworkQuestionAchievements = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};
const stateWtihEditUserAchievementUserSetting = (
  state: UsersNetworkQuestionAchievements,
  { isUserAchievementsUserSettingEnabled, userId }: EditUserAchievementUserSettingsFulfilledAction['payload']
): UsersNetworkQuestionAchievements => {
  const viewerCanAccessUserAchievements = isUserAchievementsUserSettingEnabled
    ? 'ALLOWED'
    : 'NOT_ALLOWED_BY_USER_SETTING';

  return update(state, userId, {
    isUserAchievementsUserSettingEnabled,
    viewerCanAccessUserAchievements,
  });
};
const reducer: Reducer<UsersNetworkQuestionAchievements, UserNetworkQuestionAchievementsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'USER_NETWORK_QUESTION_ACHIEVEMENTS.LOAD_PENDING':
      return moveToPending(state, [action.payload.userId]);
    case 'USER_NETWORK_QUESTION_ACHIEVEMENTS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.userId], action.payload.error);
    case 'USER_NETWORK_QUESTION_ACHIEVEMENTS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.networkQuestionAchievements);
    case 'EDIT_USER_ACHIEVEMENT_USER_SETTINGS.FULFILLED':
      return stateWtihEditUserAchievementUserSetting(state, action.payload);
    default:
      return state;
  }
};
export default reducer;
